import React, { useState } from 'react'
import PlaylistNew from '../../../assets/images/PlaylistNew.svg'
import PlaylistFilled from '../../../assets/images/PlaylistFilled.svg'
import { Flex, ResponsiveSVG } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import PlayListDrawer from '../../components_v2/PlayListDrawer/PlayListDrawer'

const Container = styled(Flex)`
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
`
const PlaylistText = styled(Text)({
  fontSize: ['14px'],
  fontFamily: 'Proxima-nova'
})

const PlaylistButton = (props) => {
  const [playlistIds, setPlaylistIds] = useState(props?.playlistIds)
  const [isDrawerOpen, setDrawerOpen] = useState(false)
  const openPlaylistDrawer = () => {
    setDrawerOpen(true)
  }

  const updatePlaylistIds = (updatedPlaylists) => {
    setPlaylistIds(updatedPlaylists)
  }

  return (
    <>
      <Container onClick={openPlaylistDrawer}>
        <ResponsiveSVG
          SVG={playlistIds.length ? PlaylistFilled : PlaylistNew}
          style={{
            cursor: 'pointer'
          }}
          width='24px'
          height='24px'
        />
        <PlaylistText>Playlist</PlaylistText>
      </Container>
      {
        <PlayListDrawer
          isOpen={isDrawerOpen}
          onClose={() => setDrawerOpen(false)}
          planEntryId={props?.classDetails?.id}
          playlists={playlistIds}
          onSuccess={updatePlaylistIds}
        />
      }
    </>
  )
}

export default PlaylistButton
